
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
    <!-- Add class 'unread' in parent div in order to activate style of unread notifications -->
    <div class="giga-notification_card" v-if="notification">
      <div class="unread_dot"></div> 
<!--       NOTIFICATION TAG -->
      <div class="notification-card_tag tag-promotion" v-if="notification.callToAction && !allImportant">
        <span>Importante</span>
      </div>
      <div class="notification-card_tag tag-general" v-if="!notification.callToAction && !allImportant">
        <span>Générale</span>
      </div>
<!--       NOTIFICATION TITLE -->
      <div class="notification-card_title">
        <b-link @click="redirect" :class="{ 'cursor-default': !redirection }">
          <h2 class="">
            <span :class="{ 'text-primary': !noTitlePrimary }">{{
              notification.entityName
            }}</span>
          </h2>
        </b-link>
      </div>
      <!-- NOTIFICATION MESSAGE -->
      <b-link @click="redirect" :class="{ 'cursor-default': !redirection }">
        <div :id="id" :visible="visible">
          <div class="notification-card_content">
            <div class="content">
              <template v-if="!notification.callToAction && notification.oldStatus && notification.newStatus" >
                <span class="content-static" v-html="content"> </span>
                <label class="content-dynamic">
                  <i>"</i>{{
                    notification.entity === "LOT"
                      ? $t("lot_status." + notification.oldStatus)
                      : notification.entity === "OPERATION"
                      ? $t("operation_status." + notification.oldStatus)
                      : notification.entity === "SIMULATION"
                      ? $t("simulation_status." + notification.oldStatus)
                      : $t(notification.oldStatus)
                  }}<i>"</i>
                </label>
                <span class="content-static"> à </span>
                <label class="content-dynamic">
                  <i>"</i>{{
                    notification.entity === "LOT"
                      ? $t("lot_status." + notification.newStatus)
                      : notification.entity === "OPERATION"
                      ? $t("operation_status." + notification.newStatus)
                      : notification.entity === "SIMULATION"
                      ? $t("simulation_status." + notification.newStatus)
                      : $t(notification.newStatus)
                  }}<i>"</i>
                </label>
              </template>
              <template v-else>
                <span v-html="notification.content"> </span>
              </template>
            </div>
            <div class="notification-card_time">
              <i>
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 0.359253C4.05 0.359253 0 4.40925 0 9.35925C0 14.3093 4.05 18.3593 9 18.3593C13.95 18.3593 18 14.3093 18 9.35925C18 4.40925 13.95 0.359253 9 0.359253ZM13.5 10.0021H9C8.61429 10.0021 8.35714 9.74497 8.35714 9.35925V3.57354C8.35714 3.18782 8.61429 2.93068 9 2.93068C9.38571 2.93068 9.64286 3.18782 9.64286 3.57354V8.7164H13.5C13.8857 8.7164 14.1429 8.97354 14.1429 9.35925C14.1429 9.74497 13.8857 10.0021 13.5 10.0021Z" fill="#8C9DAB"/>
                </svg>
              </i>
              <span>
                {{
                  moment(notification.creationDate, "x").format(
                    "DD/MM/YYYY - HH:mm"
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </b-link>
    </div>
</template>

<script>
export default {
  name: "CollapseNotification",
  props: [
    "id",
    "visible",
    "noButton",
    "notification",
    "noTitlePrimary",
    "badgeVariant",
    "allImportant",
    "redirection",
  ],
  computed: {
    content() {
      if (this.notification.callToAction) {
        return this.notification.type === "CALL_TO_ACTION_1"
          ? `Demande d'intervention`
          : this.notification.type === "CALL_TO_ACTION_3"
          ? "Question de votre consultant"
          : `Demande de chargement d’un document`;
      } else {
        return this.notification.content;
      }
    },
  },
  methods: {
    redirect() {
      if (!this.notification.callToAction) {
        this.$emit("markNotificationAsRead", this.notification.id);
      }
      if (this.redirection) {
        this.$router.push(this.notification.link);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
a {
  color: inherit;
}
.cursor-default {
  cursor: default;
}
</style>
